(function () {
  var h1 = document.querySelector('main .text-block h1');
  if (!h1) return;
  var block = h1.closest('.text-block');
  var intro = block && block.nextElementSibling;
  if (!intro || intro.tagName !== 'RTE-FORMATTER') return;
  var ps = intro.querySelectorAll('p');
  if (ps.length < 2) return;
  var rest = Array.prototype.slice.call(ps, 1);
  var link = document.createElement('a');
  link.href = '#';
  link.setAttribute('role', 'button');
  link.setAttribute('aria-expanded', 'false');
  link.style.textDecoration = 'underline';
  link.style.whiteSpace = 'nowrap';
  link.textContent = 'Read more';
  rest.forEach(function (p) { p.hidden = true; });
  ps[0].appendChild(document.createTextNode(' '));
  ps[0].appendChild(link);
  link.addEventListener('click', function (e) {
    e.preventDefault();
    var opening = rest[0].hidden;
    rest.forEach(function (p) { p.hidden = !opening; });
    link.setAttribute('aria-expanded', String(opening));
    link.textContent = opening ? 'Read less' : 'Read more';
    var target = opening ? rest[rest.length - 1] : ps[0];
    target.appendChild(document.createTextNode(' '));
    target.appendChild(link);
  });
})();
